import Vue from 'vue'
import VueI18n from 'vue-i18n'
import sharedTranslates from './shared-translates.json'
import routesTitles from './routes-titles.json'

Vue.use(VueI18n)

function loadLocaleMessages() {
	const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]/i)
	const langs = [];
	const translates = [];
	const messages = {};

	locales.keys().forEach((key) => {
		// get all available languages 
		// (just create folder with the language key e.g. folder with name 'ar' in './locales')
		const matched = key.match(/([A-Za-z0-9-_]+)\//i);
		if (matched && !langs.includes(matched[1])) {
			const lang = matched[1];
			langs.push(lang)
			messages[lang] = {};
		}

		// get all available translates keys
		// (just create js or json file in language folder e.g. create file 'page.js' in './locales/ar' folder)
		const matchedTr = key.match(/([A-Za-z0-9-_]+)\./i);
		if (matchedTr && !translates.includes(matchedTr[1])) {
			translates.push(matchedTr[1]);
		}
	})

	// set all translates messages
	locales.keys().forEach((key) => {
		// check if key is file path
		if (key.match(/[A-Za-z0-9-_,\s]+\.(json|js)/i)) {
			langs.forEach(lang => {
				translates.forEach(translate => {
					if (key.includes(`/${lang}`) && key.includes(`/${translate}.`)) {
						// match key (with js) to check if language come from js file not json
						if (key.match(/([A-Za-z0-9-_]+)\.js$/i)) {
							// so import messages which exported as default in langauge file
							messages[lang][translate] = locales(key).default;
						} else {
							// else it is json file
							messages[lang][translate] = locales(key);
						}
					}
				})
			})
		}
	})

	// routes translates
	langs.forEach(lang => {
		messages[lang].routes = {};
	})
	Object.keys(routesTitles).forEach((key) => {
		langs.forEach(lang => {
			messages[lang].routes[key] = routesTitles[key][lang];
		})
	})

	// shared translates
	Object.keys(sharedTranslates).forEach((key) => {
		langs.forEach(lang => {
			messages[lang][key] = sharedTranslates[key][lang];
		})
	})

	return messages
}

/* eslint-disable */
/* function flattenTranslations(input) {
  const result = {};
  const allLanguages = Object.keys(input);

  // Helper to recursively flatten each language
  function recurse(obj, path = [], lang) {
    for (const key in obj) {
      const value = obj[key];
      const newPath = [...path, key];

      if (typeof value === 'object' && value !== null) {
        recurse(value, newPath, lang);
      } else {
        const flatKey = newPath.join('.');
        if (!result[flatKey]) {
          result[flatKey] = { key: flatKey };
        }
        result[flatKey][lang] = value;
      }
    }
  }

  // Process each language
  for (const lang of allLanguages) {
    recurse(input[lang], [], lang);
  }

  // Fill missing translations with empty string
  for (const flatKey in result) {
    for (const lang of allLanguages) {
      if (!result[flatKey].hasOwnProperty(lang)) {
        result[flatKey][lang] = '';
      }
    }
  }

  return Object.values(result);
} */
/* eslint-enable */

const i18n = new VueI18n({
	locale: process.env.VUE_APP_I18N_LOCALE || 'ar',
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ar',
	messages: loadLocaleMessages()
})

export function changeI18nLang(lang) {
	if (lang === 'ar') {
		i18n.locale = lang;
		document.querySelector('html').dir = 'rtl';
		localStorage.setItem('pos-lang', lang);
	} else {
		i18n.locale = lang;
		document.querySelector('html').dir = 'ltr';
		localStorage.setItem('pos-lang', lang);
	}
	document.querySelector('html').lang = lang;
}

if ('pos-lang' in localStorage) {
	changeI18nLang(localStorage.getItem('pos-lang'))
} else {
	i18n.locale = 'ar';
	document.querySelector('html').dir = 'rtl';
	localStorage.setItem('pos-lang', 'ar');
}

export default i18n;

// write node js function that read files from locales files and renaming them by adding the index of the file in the folder sorted by their created date for each one of them
/* const fs = require('fs');
const path = require('path');
const dir = './locales';
const files = fs.readdirSync(dir);
files.forEach((file, index) => {
	const filePath = path.join(dir, file);
	const stats = fs.statSync(filePath);
	if (stats.isFile()) {
		const newFilePath = path.join(dir, `${index}-${file}`);
		fs.renameSync(filePath, newFilePath);	
	}
}) */

/* const fs = require('fs');
const path = require('path');
const dir = './locales';
const files = fs.readdirSync(dir);
files.forEach((file, index) => {
	const filePath = path.join(dir, file);
	const newFilePath = path.join(dir, `${index}.${file}`);
	fs.renameSync(filePath, newFilePath);	
}) */